import dayjs                   from 'dayjs';
import { ApiCollection }       from 'collections/ApiCollection';
import { reaction }            from 'mobx';
import { makeAutoObservable }  from 'mobx';
import RoleModel               from 'models/RoleModel';
import currentSession          from 'utils/currentSession';
import { translationMessages } from '../i18n';
import { EN, FR }              from 'constants/Languages';

class AppStore {
  locale = navigator.language.split('-')[0] === FR.value ? FR.value : EN.value;
  messages = translationMessages[this.locale] || translationMessages.fr;
  roleCollection = new ApiCollection(RoleModel);

  constructor() {
    makeAutoObservable(this);
    dayjs.locale(this.locale);

    reaction(
      () => currentSession.isLoggedIn,
      (isLoggedIn) => {
        if (isLoggedIn) {
          this.loadRoles();
        } else {
          this.roleCollection.clear(); // vide la collection au logout
        }
      },
      { fireImmediately: true } // au chargement de l'app
    )
  }

  loadRoles = async () => {
    if (!this.roleCollection.isLoaded) {
      await this.roleCollection.list();
    }
  }

  switchLanguage = (newLocale: string | null) => {
    if (newLocale === EN.value) {
      this.locale = EN.value;
      this.messages = translationMessages.en;
    } else {
      this.locale = FR.value;
      this.messages = translationMessages.fr;
    }
    dayjs.locale(this.locale);
  };

  switchToEnglish = () => this.switchLanguage(EN.value);

  switchToFrench = () => this.switchLanguage(FR.value);

  switchToNull = () => this.switchToFrench();
}

export const appStore = new AppStore();